import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useLocale } from "../../i18n/LocaleContext";
import {
  DEFAULT_LANGUAGE,
  isSupportedLanguage,
  localizePath,
  stripLocalePrefix,
} from "../../i18n/routing";

export default function LocaleLayout() {
  const { lang } = useParams();
  const location = useLocation();
  const { updateLocale } = useLocale();

  useEffect(() => {
    if (!isSupportedLanguage(lang)) return;
    // 仅同步 URL 语言，保留用户手动选择标记
    updateLocale({ language: lang });
  }, [lang, updateLocale]);

  if (!isSupportedLanguage(lang)) {
    const fallbackPath = localizePath(
      stripLocalePrefix(location.pathname),
      DEFAULT_LANGUAGE
    );
    return <Navigate to={fallbackPath} replace />;
  }

  return <Outlet key={location.pathname} />;
}
